import type { NetworkProfileStatus } from '../../types/api'

/** The network's own profile status, as the portal names and colours it. */
export const STATUS: { key: NetworkProfileStatus; label: string; className: string }[] = [
  { key: 'new', label: 'New', className: 'bg-sky-100 text-sky-800' },
  { key: 'active', label: 'Active', className: 'bg-green-100 text-green-800' },
  { key: 'at_risk', label: 'At risk', className: 'bg-amber-100 text-amber-800' },
  { key: 'inactive', label: 'Inactive', className: 'bg-ink-100 text-ink-600' },
]

/** Saves a downloaded blob under a name. */
export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function slug(text: string): string {
  return text.replace(/[^a-z0-9]+/gi, '-').replace(/(^-|-$)/g, '').toLowerCase()
}
